import React from 'react';
import { Hero } from '../components/home/Hero';
import { FeatureStrip } from '../components/home/FeatureStrip';
import { TheMaskSection } from '../components/home/TheMaskSection';
import { WavelengthStory } from '../components/home/WavelengthStory';
import { ScrollStory } from '../components/home/ScrollStory';
import { KitSection } from '../components/home/KitSection';
import { ProductDetails } from '../components/home/ProductDetails';
import { FaqSection } from '../components/home/FaqSection';
import { ClosingInvitation } from '../components/home/ClosingInvitation';
export function Home() {
  return <>
      <Hero data-id="element-481" data-mp="29fbzm8pxj7pk" />
      <FeatureStrip data-id="element-482" data-mp="29ek5l2bzdi1e" />
      <TheMaskSection data-id="element-483" data-mp="29i7vlri7vmbd" />
      <WavelengthStory data-id="element-484" data-mp="2dhgsv6cgu2bo" />
      <ScrollStory data-id="element-485" data-mp="2dirup0mcp005" />
      <KitSection data-id="element-486" data-mp="2dja0ooytesl9" />
      <ProductDetails data-id="element-487" data-mp="2dfm3nfu5vo1s" />
      <FaqSection data-id="element-488" data-mp="3kvabslgem9v0" />
      <ClosingInvitation data-id="element-489" data-mp="3kvtp1ov40a2p" />
    </>;
}